<template>
  <div class="place-order-wrap">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/framework/myTrading/myOrder' }">我的订单</el-breadcrumb-item>
      <el-breadcrumb-item>详情</el-breadcrumb-item>
    </el-breadcrumb>
    <header-title title="商品信息" />
    <content-table v-if="contangoVO.length !== 0" :tableData="contangoVO" labelWidth="130" />
    <header-title title="订单信息" />
    <content-table v-if="contangoOrderVO.length !== 0" :tableData="contangoOrderVO" labelWidth="146" />
    <!--卖方订单详情的时候才显示-->
    <div v-if="$route.params.type === 'S'">
      <header-title title="升贴水单价支付申请记录" />
      <contango-pay-list  v-if="orderCode" :orderCode="orderCode" />
      <header-title title="挂牌商品履约金解冻申请记录" />
      <thaw-amount-list v-if="orderCode" :orderCode="orderCode" />
    </div>
    <div class="button-wrap over">
      <el-button type="primary plain" @click="back">返回</el-button>
    </div>
    <div class="empty-box"></div>
  </div>
</template>

<script>
import thawAmountList from './components/ThawAmountList'
import contangoPayList from './components/ContangoPayList'

export default {
  name: 'orderDetail',
  components: {
    thawAmountList,
    contangoPayList
  },
  data () {
    return {
      contangoOrderVO: [], // 订单表格数据
      contangoVO: [], // 商品表格数据
      orderCode: '' // 订单编号
    }
  },
  mounted () {
    this.getDetails()
  },
  methods: {
    // 获取详情
    getDetails () {
      const url = this.$API.myOrder.getContangoOrderDetail
      const param = {
        id: this.$route.params.id,
        directionType: this.$route.params.type
      }
      this.$http.post(url, param).then(res => {
        const orderData = res.data.contangoOrderVO
        const goodsData = res.data.contangoVO
        this.orderCode = orderData.orderCode // 订单编号
        this.contangoOrderVO = [ // 订单信息
          { key: '升贴水单价', value: orderData.liftingWater },
          { key: '数量', value: orderData.orderQuantity },
          { key: '总金额', value: orderData.amount },
          { key: '应付挂牌商品履约金', value: this.$route.params.type === 'B' ? orderData.buyerDeposit : orderData.sellerDeposit },
          { key: '卖方', value: orderData.sellerName },
          { key: '买方', value: orderData.buyerName },
          { key: '下单时间', value: orderData.orderDate },
          { key: '状态', value: this.getStatus(orderData.buyerOrderStatus, orderData.sellerOrderStatus) },
          { key: '已交收数量', value: this.$route.params.type === 'B' ? orderData.buyerDeliveredQuantity : orderData.sellerDeliveredQuantity },
          { key: '备注', value: orderData.remark },
        ]
        this.contangoVO = [ // 商品信息
          { key: '报价编号', value: goodsData.contangoCode },
          { key: '品种', value: goodsData.varietyName },
          { key: '品类', value: goodsData.category },
          { key: '品牌', value: goodsData.brandName },
          { key: '等级', value: goodsData.grade },
          { key: '产地', value: goodsData.origin },
          { key: '榨季', value: goodsData.season },
          { key: '购销计划', value: goodsData.contract },
          { key: '可交货时间', value: goodsData.deliveryDate.substr(0, 10) },
          { key: '交货地', value: goodsData.addressStr },
          { key: '交货方式', value: this.$utils.getStatusName(goodsData.deliveryType, this.$key.releaseQuotation.deliveryType) },
          { key: '仓租费起始日', value: goodsData.warehouseRentStartDate.substr(0, 10) },
          { key: '货款要求', value: goodsData.loanRequire + '前支付' },
          { key: '仓库名', value: goodsData.wareHouseAddress || '无' },
        ]
      })
    },
    // 获取状态
    getStatus (buyerOrderStatus, sellerOrderStatus) {
      // 根据路由参数，判断当前是要用买方（B）还是卖方(S)的状态
      const status = this.$route.params.type === 'B' ? buyerOrderStatus : sellerOrderStatus
      // 决定当前所需的状态数组
      const statusList = this.$route.params.type === 'B' ? this.$key.quotation.buyerStatus : this.$key.quotation.sellerStatus
      const statusItem = statusList.filter((item) => { // 找到匹配当前状态的那个项
        return item.id === status
      })
      return statusItem[0].name // 返回想要的状态描述
    },
    // 返回
    back () {
      this.$router.push({ path: '/framework/myTrading/myOrder' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .place-order-wrap{
    margin-top: 20px !important;
    .form_wrap{
      margin-top: 20px;
      margin-bottom: 35px;
      .price{
        font-size: 30px;
        color: #ff7f00;
        margin-right: 6px;
        vertical-align: bottom;
      }
      .num{
        width: 130px;
        margin-right: 6px;
      }
      .tip{
        font-size: 12px;
        color: #ff1010;
        margin-left: 10px;
      }
      /deep/ .el-textarea{
        width: 350px;
      }
    }
    .button-wrap{
      display: flex;
      justify-content: center;
      align-items: center;
      button{
        margin-top: 40px;
        margin-bottom: 80px;
      }
    }
    .empty-box{
      height: 150px;
    }
  }
</style>
